module.exports = __webpack_public_path__ + "img/EG.7213ac95.svg";